module.exports = __webpack_public_path__ + "static/media/spacex-bg-image.aa2f41e2.webp";